'use strict';

const store = require('../../../modules/store/results');
const actions = require('../../../modules/store/results/action_creators');
const trackingUtils = require('../../../modules/utils/tracking.utils');

const calculateTitle = function(translations, type) {
    const parseValue = {
        DURATION: 'fastestTitle',
        SMART_SORTING: 'cheapestTitle',
        ODIRATING_SORTING: 'recommendedTitle',
    };
    return translations.get(parseValue[type]);
};

const calculateHoverMessage = function(translations, type) {
    const parseValue = {
        ODIRATING_SORTING: 'recommendedHoverMessage',
    };
    return translations.get(parseValue[type]);
};

const calculateHoverLinkMessage = function(translations, type) {
    const parseValue = {
        ODIRATING_SORTING: 'recommendedHoverLinkMessage',
    };
    return translations.get(parseValue[type]);
};

const calculateHoverLink = function(translations, type) {
    const parseValue = {
        ODIRATING_SORTING: 'recommendedHoverLink',
    };
    return translations.get(parseValue[type]);
};

const calculateBeforeIcon = function(type) {
    const parseValue = {
        DURATION: 'odf-icon-time',
        SMART_SORTING: 'odf-icon-cash',
        ODIRATING_SORTING: 'odf-icon-star',
    };
    return parseValue[type];
};

const calculateAfterIcon = function(type) {
    const parseValue = {
        ODIRATING_SORTING: 'odf-icon-information',
    };
    return parseValue[type];
};

module.exports = Backbone.View.extend({
    selectors: {
        sorting_tab_popup: '.sorting_tab_popup',
    },

    events: {
        'click': 'onClickTab',
        'click .sorting_tab_popup_link': 'onClickHoverLink',
    },

    initialize(options) {
        const translations = this.model.translations;
        this.template = options.template;
        this.selector = options.el;
        this.infoTemplate = options.infoTemplate;
        this.sortType = options.sortType;
        this.hoverEnabled = options.tests.addBestInfoEnabled;
        this.viewInjector = options.viewInjector(this);
        this.listenTo(this.model.sortingType, 'change:type', this.toggle);
        this.templateData = this.hoverEnabled ? this.getTemplateDataWithHover(translations) : this.getTemplateData(translations);
        this.bindHoverMessage();
    },

    getTemplateData(translations) {
        return {
            title: calculateTitle(translations, this.sortType.value),
            beforeIcon: calculateBeforeIcon(this.sortType.value),
        };
    },

    getTemplateDataWithHover(translations) {
        return {
            title: calculateTitle(translations, this.sortType.value),
            afterIcon: calculateAfterIcon(this.sortType.value),
            hoverMessage: calculateHoverMessage(translations, this.sortType.value),
            hoverLinkMessage: calculateHoverLinkMessage(translations, this.sortType.value),
            hoverLink: calculateHoverLink(translations, this.sortType.value),
        };
    },

    bindHoverMessage() {
        if (this.hoverEnabled && this.sortType.value === 'ODIRATING_SORTING') {
            this.hoverLoaded = false;
            this.$el.hover(() => this.onMouseOver(), () => this.onMouseLeave());
        }
    },

    render() {
        this.$el.html(this.template(this.templateData));
        this.viewInjector.create('tabInfo');
        return this;
    },

    onMouseOver() {
        this.$el.find(this.selectors.sorting_tab_popup).addClass('opened');
        if (!this.hoverLoaded) {
            this.hoverLoaded = true;
            trackingUtils.trackEvent('sorting_info', 'sorting_info_best_bubble');
        }
    },

    onMouseLeave() {
        this.$el.find(this.selectors.sorting_tab_popup).removeClass('opened');
    },

    onClickTab() {
        if (!this.$el.hasClass('od-sorting-tab-selected')) {
            store.dispatch(actions.sortBy(this.sortType.value));
            Odigeo.trigger('sorting-tabs:sortResultsBy', this.sortType);
            trackingUtils.trackEvent('sort_option', this.sortType.trackingLabel);
        }
    },

    onClickHoverLink() {
        trackingUtils.trackEvent('sorting_info', 'sorting_info_help_clicked');
    },

    toggle(model, type) {
        const tabSelected = this.sortType.value === type;
        this.$el.toggleClass('od-sorting-tab-selected', tabSelected);
        this.$el.find('.sorting_tab_data').toggleClass('odf-text-mono-color-04', !tabSelected);
        if (Odigeo.SessionScope.isMetaFlights) {
            this.$el.find('.sorting_tab_data').toggleClass('odf-strong', tabSelected);
        }
    },
});
